export default class Addon
{
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...Addon.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.DOM.$quantity = this.DOM.$el.querySelector(this.options.selectorStepper);
        this.DOM.$description = this.DOM.$el.querySelector(this.options.selectorTicketsDesc)
        if (this.DOM.$quantity && this.DOM.$description) {
            this.DOM.$quantity.addEventListener('change', this.onUpdateProductQuantity.bind(this))
            this.onUpdateProductQuantity();
        }
        this.DOM.$price = this.DOM.$el.querySelector(this.options.selectorPrice)
        if (this.DOM.$price) {
            this.DOM.pricePerUnit = this.DOM.$price.dataset[this.options.attrPriceAmount]
            this.formatter = new Intl.NumberFormat("en-UK", {
                style: "currency",
                currency: this.DOM.$price.dataset[this.options.attrPriceCurrency],
                trailingZeroDisplay: "stripIfInteger",
                useGrouping: "min2",
            })
        }
        this.onUpdateProductQuantity()
    }

    onUpdateProductQuantity() {
        this.updateDescription()
        this.updatePrice()
    }

    updateDescription() {
        let totalTickets = this.DOM.$description.dataset[this.options.attrTicketCount] * this.DOM.$quantity.value
        let description = totalTickets + " extra " + (totalTickets > 1 ? 'tickets' : 'ticket')
        this.DOM.$description.innerText = description
    }

    updatePrice() {
        if (!this.DOM.$price) {
            return
        }
        this.DOM.$price.innerText = this.formatPrice(this.DOM.pricePerUnit * this.DOM.$quantity.value)
    }

    formatPrice(price) {
        return this.formatter.format(
            price,
        )
    }
}


Addon.prototype.defaults = {
    attrTicketCount: "ticketCount",
    attrPriceAmount: "priceAmount",
    attrPriceCurrency: "priceCurrency",
    selectorStepper: ".js-cartProductQuantity",
    selectorTicketsDesc: ".js-addonTicketsDesc",
    selectorPrice: ".js-priceAmount",
}